export const styles = theme => ({

  // color
  statusValue: {
    fontSize: '32px',
    fontWeight: 'bold',
    fontFamiry: theme.typography.fontKanit,
  },
  statusText: {
    borderRadius: 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamiry: theme.typography.fontKanit,
    fontSize: 12,
  },
  table: {
    maxWidth: 250,
  },
  hiddenLine: {
    borderBottom: 0,
    fontSize: '12px',
  },

  // color status
  status: {
    borderRadius: 4,
  },
  colorRedMax: {
    background: '#B02418',
    color: '#fff',
  },
  colorRed: {
    background: '#EA3423',
    color: '#fff',
  },
  colorYellow: {
    background: '#F7C142',
  },
  colorGreen: {
    background: '#4EAC5B',
    color: '#fff',
  },
});